import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS, LOGO_URL } from "../mock/mock";
import { Button } from "./ui/button";

const Logo = () => (
  <Link to="/" className="flex items-center shrink-0">
    <img src={LOGO_URL} alt="mattressDIRECT.in - Better Sleep. Direct To You." className="h-12 md:h-[65px] w-auto" />
  </Link>
);

export default function Header({ onEnquire }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [location.pathname]);

  const handleNav = (path) => {
    if (path.startsWith("/#")) {
      navigate("/");
      setTimeout(() => {
        const el = document.getElementById(path.replace("/#", ""));
        if (el) el.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      navigate(path);
    }
    setOpen(false);
  };

  return (
    <header className={`sticky top-0 z-50 w-full border-b transition-all ${scrolled ? "bg-white/95 backdrop-blur border-slate-200 shadow-sm" : "bg-white border-transparent"}`}>
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="flex h-[84px] items-center justify-between">
          <Logo />

          <nav className="hidden lg:flex items-center gap-7">
            {NAV_LINKS.map((l) => (
              <button
                key={l.label}
                onClick={() => handleNav(l.path)}
                className="text-[13.5px] font-medium text-slate-600 hover:text-[#1c2e3a] transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-0.5 after:w-0 after:bg-[#f4520b] hover:after:w-full after:transition-all"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <Button onClick={onEnquire} className="hidden sm:inline-flex bg-[#1c2e3a] hover:bg-[#29424f] text-white rounded-md px-5 h-10 text-sm font-semibold">
              Enquire Now
            </Button>
            <button className="lg:hidden text-[#1c2e3a]" onClick={() => setOpen(!open)} aria-label="Menu">
              {open ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <nav className="flex flex-col px-4 py-3">
            {NAV_LINKS.map((l) => (
              <button key={l.label} onClick={() => handleNav(l.path)} className="text-left py-3 text-[15px] font-medium text-slate-700 border-b border-slate-100 last:border-0">
                {l.label}
              </button>
            ))}
            <Button onClick={onEnquire} className="mt-3 bg-[#1c2e3a] hover:bg-[#29424f] text-white rounded-md h-11">Enquire Now</Button>
          </nav>
        </div>
      )}
    </header>
  );
}
